/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import store from "@/store/store";
const limit = 15;
export default [
  {
    path: "/accounts",
    url: "/accounts",
    name: "Accounts",
    icon: "UsersIcon",
    component: () => import("@/views/Accounts/List.vue"),
    meta: {
      adminOnly: true,
      sidebar: true,
      route: true,
      pageTitle: "All Accounts",
      rule: "editor",

      limit,
      sort: "updatedAt:DESC"
    }
  },
  {
    path: "/account/:id",
    name: "account-detail",
    component: () => import("@/views/Accounts/View.vue"),
    meta: {
      route: true,
      pageTitle: "Account Details",
      breadcrumb: [
        { title: "All Accounts", url: "/" },
        { title: "Client Details", active: true }
      ],
      adminOnly: true,
      view: true,
      accountView: true
    }
  },
  {
    path: "/transactions",
    url: "/transactions",
    name: "Transactions",
    slug: "transactions",
    icon: "FileTextIcon",
    component: () => import("@/views/Transactions/List.vue"),
    meta: {
      adminOnly: true,
      route: true,
      pageTitle: "All Transactions",
      rule: "editor",
      sidebar: true,

      api: "/transactions",
      limit,
      sort: "updatedAt:DESC"
    }
  },

  {
    path: "/trucks",
    url: "/trucks",
    name: "Trucks",
    slug: "trucks",
    icon: "TruckIcon",
    component: () => import("@/views/Trucks/List.vue"),
    meta: {
      adminOnly: true,
      route: true,
      pageTitle: "All Trucks",
      rule: "editor",
      sidebar: true,

      state: "trucks",
      limit,
      sort: "updatedAt:DESC",
      api: `/trucks?_sort=updatedAt:DESC&_limit=3`,
      apiCount: "/trucks/count"
    }
  },
  {
    path: "/scanners",
    url: "/scanners",
    name: "Scanners",
    slug: "scanners",
    icon: "SmartphoneIcon",
    component: () => import("@/views/Scanners/List.vue"),
    meta: {
      adminOnly: true,
      route: true,
      pageTitle: "All Scanners",
      rule: "editor",
      sidebar: true,
      scannerList: true
    }
  },
  {
    path: "/products",
    url: "/products",
    name: "Products",
    slug: "products",
    icon: "StopCircleIcon",
    component: () => import("@/views/Products/List.vue"),
    meta: {
      adminOnly: true,
      route: true,
      pageTitle: "All Products",
      rule: "editor",
      sidebar: true,
      productList: true
    }
  },
  {
    path: "/product/:id",
    name: "product-detail",
    component: () => import("@/views/Products/View.vue"),
    meta: {
      route: true,
      pageTitle: "Product Details",
      breadcrumb: [
        { title: "All Product", url: "/products" },
        { title: "Product Details", active: true }
      ],
      superAdmin: true,
      apiRoute: "products",
      productView: true
    }
  },
  {
    path: "/load-credits/:id",
    name: "Load Credits",
    url: "/load-credits",
    icon: "DollarSignIcon",
    slug: "load-credits",
    component: () => import("@/views/LoadFundsAdmin.vue"),
    meta: {
      route: true,
      pageTitle: "Load Credits",
      adminOnly: true,
      apiRoute: "accounts"
    }
  },
  {
    path: "/message-board",
    name: "Message Board",
    url: "/message-board",
    icon: "MessageSquareIcon",
    slug: "message-board",
    component: () => import("@/views/MessageBoard/View.vue"),
    meta: {
      adminOnly: true,
      route: true,
      pageTitle: "Message Board",
      rule: "editor",
      sidebar: true
    }
  },
  {
    path: "/promotions",
    name: "Promotions",
    url: "/promotions",
    icon: "GiftIcon",
    slug: "promotion",
    component: () => import("@/views/Promotions/View.vue"),
    meta: {
      adminOnly: true,
      route: true,
      pageTitle: "View Promotions Code",
      rule: "editor",
      sidebar: true
    }
  }
];
